import { useKeyCombinationTrigger } from '@core/logic';
import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { photosState, togglePhotos } from '@photos/components/PhotosInViewport/state';
import { useSnapshot } from 'valtio';
import { PhotosFilters } from './PhotosFilters';

export const PhotosToggle = () => {
  const { showPhotos } = useSnapshot(photosState);

  useKeyCombinationTrigger('Alt', 'p', () => togglePhotos());

  return (
    <Stack direction="row" justifyContent="space-between">
      <FormControlLabel
        label="Photos"
        control={
          <Checkbox
            color="primary"
            checked={showPhotos}
            onChange={(event) => togglePhotos(event.target.checked)}
          />
        }
      />
      <PhotosFilters />
    </Stack>
  );
};
